/**
 * Copyright © Veeam Software Group GmbH.
 */

import { MonthsRepresentation } from '@veeam-vspc/models/web-controllers';

export type Months = MonthsRepresentation;
export const Months = MonthsRepresentation;
